import React from 'react'
import QRCode from 'qrcode.react';
import styled from '@emotion/styled';

const ARViewerContainer = styled('div')({
});

const Title = styled('h3')(({ theme }) => ({
    fontFamily: theme.typography.infoKey.fontFamily,
    fontWeight: theme.typography.infoKey.fontWeight,
    color: theme.typography.infoKey.color,
    alignText: 'center',
}));


const ARViewer = ({fileUrl, title}) => {
  return (
    <ARViewerContainer>
        <Title>{title}</Title>
        <QRCode value={fileUrl} size={128} />
    </ARViewerContainer>
  )
}

export default ARViewer